export const NWD_VERSION = 'network-dashboard@v9.16.4';
